import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import { DropDownProvider, Hotspot } from "core/DropDown/index.js";
import DropDown from "./DropDown";
import AvatarWithBell from "core/SiteHeader/components/AvatarWithBell";

// data
import {
    AUTH_MENU_TWO_COL_WIDTH,
    AUTH_MENU_THREE_COL_WIDTH,
} from "core/SiteHeader/TabletDesktop/Layout/constants.js";
import { trackheaderAccountAvatarClicked } from "core/trackEvent";

// helpers
import { disableBellNotifications } from "core/SiteHeader/helpers.js";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const AvatarStyled = styled.div`
    display: flex;
    justify-content: flex-end;
`;
const UlStyled = styled.ul`
    display: flex;
    align-items: center;
`;
const AvatarDropDownWrapper = styled.li`
    height: ${convertPxToRem(40)};
`;
const HotSpotStyled = styled(Hotspot)`
    /* needed for focus circle */
    border-radius: 50%;
`;

// component
const AuthMenu = ({ onFocusScroll, isDisabled = false }) => {
    const { isDarkMode, authMenuHasThreeColumns, setHideBell } = useSiteHeader();

    const width = authMenuHasThreeColumns
        ? AUTH_MENU_THREE_COL_WIDTH
        : AUTH_MENU_TWO_COL_WIDTH;

    const onOpen = () => {
        disableBellNotifications();
        trackheaderAccountAvatarClicked();
    };

    const onClose = () => {
        setHideBell(true);
    };

    return (
        <AvatarStyled>
            <UlStyled>
                <AvatarDropDownWrapper>
                    <DropDownProvider
                        id="auth-menu"
                        isDarkMode={isDarkMode}
                        hideOnScroll
                        width={width}
                        alignment="right"
                        padding={0}
                        zIndex={2}
                        onOpen={onOpen}
                        onClose={onClose}
                        isDisabled={isDisabled}
                    >
                        <HotSpotStyled onFocus={onFocusScroll}>
                            <AvatarWithBell />
                        </HotSpotStyled>
                        <DropDown />
                    </DropDownProvider>
                </AvatarDropDownWrapper>
            </UlStyled>
        </AvatarStyled>
    );
};

export default AuthMenu;

import PropTypes from "prop-types";

// prop-types
AuthMenu.propTypes = {
    onFocusScroll: PropTypes.func,
    isDisabled: PropTypes.bool,
};
